import organisationUnits from "./organisation-units";

export const ORGANISATION_UNITS_NAMESPACE = `organisations/organisationUnits`;

export default organisationUnits;
